import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import './App.css';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Preloader from './components/Preloader';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PodcastsPage from './pages/PodcastsPage';
import StoriesPage from './pages/StoriesPage';
import StoryDetailPage from './pages/StoryDetailPage';
import AdminPage from './pages/AdminPage';

function App() {
  return (
    <HelmetProvider>
      <Preloader>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<HomePage />} />
                <Route path="services" element={<ServicesPage />} />
                <Route path="services/:slug" element={<ServiceDetailPage />} />
                <Route path="about" element={<AboutPage />} />
                <Route path="contact" element={<ContactPage />} />
                <Route path="podcasts" element={<PodcastsPage />} />
                <Route path="stories" element={<StoriesPage />} />
                <Route path="stories/:slug" element={<StoryDetailPage />} />
                <Route path="admin" element={<AdminPage />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster 
            position="bottom-right"
            toastOptions={{
              style: {
                background: '#000',
                border: '1px solid rgba(255,255,255,0.1)',
                color: '#fff',
              }
            }}
          />
        </div>
      </Preloader>
    </HelmetProvider>
  );
}

export default App;
